import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'normalize.css';
import 'ionicons/dist/css/ionicons.css';
// require styles
import 'swiper/dist/css/swiper.css';

//import '../scss/element-theme.scss'
import Filters from '../utlis/filters'

let components = [
    require('./context-menu/ContextMenu'),
    require('./footer/Footer'),
    require('./header/Header'),
    require('./layout/DefaultLayout'),
    require('./main-body/MainBody'),
    require('./main-body/FormBody'),
    require('./main-body/ListBody'),
    require('./tab-view/TabView'),
    require('./tab-view/TabNav'),
    require('./scrollbar/Scrollbar'),
    require('./siderbar/Siderbar'),
];


let install = function(Vue ) {


    Vue.use(VueAwesomeSwiper, /* { default global options } */);


    for(let key in Filters){
        Vue.filter(key,Filters[key]);
    }

    /* istanbul ignore if */
    if (install.installed) return;

    components.forEach(function (e) {
        Vue.component(`Fb${e.default.name}`,e.default);
    })
};

export default {
    install:install
}
